let swiperShopAll = new Swiper(".shop-all-slider__swiper", {
    slidesPerView: 2,
		autoHeight: true,
		loop: true,
		freeMode: true,
		speed: 5000,
		spaceBetween: 40,
		autoplay: {
			delay: 1,
			disableOnInteraction: true,
		},
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    breakpoints: {
        1300:{
          slidesPerView: 5,
          spaceBetween: 111,
          speed: 600,
					autoplay: false,
					loop: false,
        },
        900:{
					slidesPerView: 3,
					speed: 600,
					spaceBetween: 40,
					autoplay: false,
					loop: false,
        },
    },   
});

const swiperShopAllLogos = new Swiper('.shop-all-swiper__partners', {
	loop: true,
	slidesPerView: 4,
	allowTouchMove: false,
	freeMode: true,
	speed: 2500,
	spaceBetween: 40,
	autoplay: {
		delay: 1,
		disableOnInteraction: true,
	},
	breakpoints: {
		900:{
			slidesPerView: 5,
			spaceBetween: 111,
		}
	}, 
});